import Locale from "../interfaces/Locale";

const files = import.meta.glob<Record<string, unknown>>(
  ["./messages/*/*.json", "../features/*/i18n/*/*.json"],
  { eager: true, import: "default" }
);

export const messages: Record<Locale, Record<string, unknown>> = { en: {}, es: {} };

Object.entries(files).forEach(([path, content]) => {
  const [locale, file] = path.split("/").slice(-2);
  messages[locale as Locale][file.replace(".json", "")] = content;
});
